import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DappList = _resolveComponent("DappList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DappList, {
      listName: "Upcoming Voting",
      dapps: _ctx.upcomingMatches
    }, null, 8, ["dapps"]),
    (_ctx.expiredMatches.length !== 0)
      ? (_openBlock(), _createBlock(_component_DappList, {
          key: 0,
          listName: "Past Votings",
          dapps: _ctx.expiredMatches
        }, null, 8, ["dapps"]))
      : _createCommentVNode("", true)
  ], 64))
}